if (!customElements.get("back-in-stock-alert-drawer")) {
  customElements.define(
    "back-in-stock-alert-drawer",
    class BackInStockAlertDrawer extends HTMLElement {
      constructor() {
        super();

        const closeElementsSelectors = [
          ".back-in-stock-alert-drawer-close",
          ".back-in-stock-alert-overlay",
        ];

        this.querySelectorAll(closeElementsSelectors).forEach((closeEl) => {
          closeEl.addEventListener("click", () => {
            this.hide();
          });
        });

        // scope to own section so two product sections on one page don't cross-open
        this.sectionId = this.id.replace("BackInStockAlertDrawer-", "");
        this.openBtn = document.getElementById(
          `Button-BackInStockAlertForm-${this.sectionId}`
        );

        this.openBtn?.addEventListener("click", (e) => {
          this.show(e.target);
        });

        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            const currentVariant = event.data.variant;
            this.resetStatus();
            this.updateInfo(currentVariant);
          }
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      get closeCursor() {
        return this.querySelector("modal-close-cursor");
      }

      hide() {
        this.removeAttribute("open");
        this.classList.remove("modal--open");
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
        this.closeCursor?.deactivate();
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        this.classList.add("modal--open");
        document.body.classList.add("overflow-hidden");

        this.addEventListener(
          "transitionend",
          () => {
            trapFocus(this, this.querySelector('[role="dialog"]'));
          },
          { once: true }
        );
        this.closeCursor?.activate();
      }

      updateInfo(currentVariant) {
        const formattedOptions =
          currentVariant.options.length > 1
            ? currentVariant.options.join(" / ")
            : currentVariant.options[0] || "";

        const optionsEl = this.querySelector(
          ".back-in-stock-alert-product-options"
        );
        const inputOptions = this.querySelector(
          "#BackInStockAlert-options"
        );

        if (optionsEl) optionsEl.textContent = formattedOptions;
        if (inputOptions) inputOptions.value = formattedOptions;

        const inputReturn = this.querySelector(
          "#BackInStockAlert-return"
        );

        if (inputReturn && inputReturn.value.includes("variant=")) {
          const newUrl = inputReturn.value.replace(
            /variant=\d+/,
            `variant=${currentVariant.id}`
          );
          inputReturn.value = newUrl;
        }
      }

      resetStatus() {
        const messages = this.querySelectorAll(".form__message");
        messages.forEach((el) => el.remove());
      }
    }
  );
}
